import cn from "@/v2-ui/utils/utils.cn"
import LicenseFeatureGroupRegistryPaneSkeleton from "@/v2-backoffice-client/license/featureGroup/compose/registry/LicenseFeatureGroupRegistryPaneSkeleton"
import {
  REGISTRY_ITEM_CLASS,
  REGISTRY_PANE_CLASS,
  type RegistryType,
} from "@/v2-backoffice-client/license/featureGroup/compose/registry/license.featureGroup.registry.utils"

export type LicenseFeatureGroupRegistryTypesPaneProps = {
  types: readonly RegistryType[]
  isLoading: boolean
  selectedTypeCode: number | null
  onSelect(typeCode: number | null): void
}

// The first column: every grantable feature type with how many features it
// holds (after the filter). Picking one again clears it.
function LicenseFeatureGroupRegistryTypesPane(
  props: LicenseFeatureGroupRegistryTypesPaneProps,
) {
  const { types, isLoading, selectedTypeCode, onSelect } = props

  return (
    <div className={REGISTRY_PANE_CLASS}>
      {isLoading && types.length === 0 ? (
        <LicenseFeatureGroupRegistryPaneSkeleton />
      ) : (
        <ul>
          {types.map((type) => (
            <li key={type.code}>
              <button
                type="button"
                className={cn(
                  REGISTRY_ITEM_CLASS,
                  type.code === selectedTypeCode && "bg-muted font-medium",
                )}
                aria-pressed={type.code === selectedTypeCode}
                data-feature-code="UI_BackofficeFeatureGroup_Registry_Type"
                onClick={() => {
                  onSelect(type.code === selectedTypeCode ? null : type.code)
                }}
              >
                <span className="min-w-0 flex-1 truncate">{type.name}</span>
                <span className="tabular-nums text-muted-foreground">
                  {type.count}
                </span>
              </button>
            </li>
          ))}
          {types.length === 0 && !isLoading && (
            <li className="px-2.5 py-3 text-xs text-muted-foreground">
              Nothing matches.
            </li>
          )}
        </ul>
      )}
    </div>
  )
}

export default LicenseFeatureGroupRegistryTypesPane
